/* ss-track.js — the theme's one analytics helper (taxonomy: 06-apps/website/analytics/events.v1.json).
   window.ssTrack(name, params) publishes an ss_* event to Shopify's event bus (Shopify.analytics.publish),
   where the ss-ga4-events custom pixel forwards it to GA4, and mirrors it to window.dataLayer.
   It adds the common parameters (surface, template, theme_version, page_path, QA flag) and never sends
   free text or personal data. layout/theme.liquid holds a queue stub in <head> so inline section scripts
   (popup, buy dock) can call ssTrack before this file loads. Also owns ss_section_view and ss_cta_click. */
(function () {
  'use strict';
  var VERSION = '1.4.0';
  var MAX = 100;
  var NAME_RE = /^ss_[a-z0-9_]{1,36}$/;
  var stub = window.ssTrack;
  var queued = (stub && stub.q) || [];

  function qaFlag() {
    var on = false;
    try {
      var p = new URLSearchParams(location.search);
      var v = p.get('ss_qa');
      if (v === '1') localStorage.setItem('ss_qa', '1');
      if (v === '0') localStorage.removeItem('ss_qa');
      on = localStorage.getItem('ss_qa') === '1';
    } catch (e) {}
    try { if (new URLSearchParams(location.search).get('ss_debug') === '1') on = true; } catch (e) {}
    try { if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') on = true; } catch (e) {}
    try { if (window.Shopify && window.Shopify.designMode) on = true; } catch (e) {}
    return on;
  }

  function surfaceOf(template, path) {
    var name = template.split('.')[0], suffix = template.split('.')[1] || '';
    if (name === 'index') return 'home';
    if (name === 'product') {
      if (suffix === 'hand') return 'pdp_hand';
      if (suffix === 'head') return 'pdp_head';
      if (suffix === 'filter-hand' || suffix === 'filter-head') return 'pdp_filter';
      if (suffix === 'infuser') return 'pdp_infuser';
      return 'pdp_other';
    }
    if (name === 'cart') return 'cart';
    if (name === 'collection' || name === 'list-collections') return 'collection';
    if (name === 'search') return 'search';
    if (name === 'article') return 'article';
    if (name === 'blog') return 'blog';
    if (name === 'page') {
      if (suffix.indexOf('compare-') === 0) return 'compare';
      if (suffix === 'the-proof') return 'proof';
      if (suffix === 'zero-filtration') return 'zero_filtration';
      if (suffix.indexOf('meta-landing') === 0) return 'landing_meta';
      if (suffix === 'installation') return 'guide';
      if (suffix === 'your-water') return 'filtermap';
      if (suffix === 'hello') return 'hello';
      if (path && path.indexOf('/pages/installation') === 0) return 'guide';
    }
    return 'page_other';
  }

  function gaClientId() {
    try {
      var m = document.cookie.match(/(?:^|; )_ga=GA\d\.\d\.(\d+\.\d+)/);
      return m ? m[1] : undefined;
    } catch (e) { return undefined; }
  }

  var template = (document.body && document.body.getAttribute('data-ss-template')) || '';
  var path = String(location.pathname || '').slice(0, MAX);
  var qa = qaFlag();
  var common = {
    surface: surfaceOf(template, path),
    template: template.slice(0, MAX),
    theme_version: (function () { try { return String(window.Shopify.theme.id); } catch (e) { return undefined; } })(),
    page_path: path
  };
  if (qa) { common.traffic_type = 'internal'; common.debug_mode = true; }
  // A/B arm on the Meta landing (snippets/ss-landing-arm.liquid sets it in <head>), e.g. "ml1-b".
  (function () {
    var root = document.documentElement, ab = root.getAttribute('data-ss-ab'), arm = root.getAttribute('data-ss-arm');
    if (ab && arm) common.ab_arm = ab + '-' + arm;
  })();

  function clean(value) {
    if (typeof value === 'number') return isFinite(value) ? value : undefined;
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') { var s = value.trim().slice(0, MAX); return s || undefined; }
    return undefined;
  }

  // Outbox: Shopify delivers published events to pixels asynchronously, so an event published in the click
  // that navigates away is often lost (3 of 8 same-site clicks at 2 s arrived, 2026-10-15). Events published
  // with {handoff: true} get an event id and a copy in sessionStorage (shared with the pixel sandbox). The
  // pixel removes the copy when the event reaches it; the next page's pixel sends whatever is left, once.
  var OUTBOX = 'ss_track_outbox';
  function outboxAdd(rec) {
    try {
      var list = JSON.parse(sessionStorage.getItem(OUTBOX) || '[]');
      if (!Array.isArray(list)) list = [];
      list.push(rec);
      sessionStorage.setItem(OUTBOX, JSON.stringify(list.slice(-20)));
    } catch (e) {}
  }
  function newEid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }

  function track(name, params, opts) {
    if (typeof name !== 'string' || !NAME_RE.test(name)) return;
    var out = {};
    var k;
    if (params && typeof params === 'object') {
      for (k in params) if (Object.prototype.hasOwnProperty.call(params, k)) {
        var v = clean(params[k]);
        if (v !== undefined) out[k] = v;
      }
    }
    for (k in common) if (common[k] !== undefined && out[k] === undefined) out[k] = common[k];
    var cid = gaClientId();
    if (cid) out.ga_client_id = cid;
    if (opts && opts.handoff) {
      out.eid = newEid();
      var copy = {};
      for (k in out) if (k !== 'ga_client_id') copy[k] = out[k];
      outboxAdd({ eid: out.eid, name: name, params: copy, loc: String(location.href).slice(0, 420),
        ref: String(document.referrer || '').slice(0, 420), title: String(document.title || '').slice(0, 100), ts: Date.now() });
    }
    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: name };
      for (k in out) if (k !== 'ga_client_id' && k !== 'eid') dl[k] = out[k];
      window.dataLayer.push(dl);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, out);
      }
    } catch (e) {}
    if (qa) { try { console.debug('[ss-track]', name, out); } catch (e) {} }
  }
  track.version = VERSION;
  track.qa = qa;
  track.common = common;
  window.ssTrack = track;
  for (var i = 0; i < queued.length; i++) { try { track.apply(null, queued[i]); } catch (e) {} }

  // ss_init: internal signal for the ss-ga4-events pixel to start gtag now, so the first click is not lost
  // waiting for it. Not an analytics event: no dataLayer entry, the pixel never forwards it to GA4.
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      var initData = {};
      var initCid = gaClientId();
      if (initCid) initData.ga_client_id = initCid;
      window.Shopify.analytics.publish('ss_init', initData);
    }
  } catch (e) {}

  // ─── ss_section_view: template sections inside <main>, keyed by the wrapper id after the last "__".
  function sectionKey(el) {
    var id = el && el.id ? el.id : '';
    var at = id.lastIndexOf('__');
    return at >= 0 ? id.slice(at + 2).slice(0, MAX) : '';
  }
  var sections = Array.prototype.slice.call(document.querySelectorAll('main > .shopify-section[id^="shopify-section-template--"]'));
  // On an A/B page the other arm's sections are display:none; leaving them out keeps each arm's positions
  // the page as seen, so arm A reports the same positions as before the test (Codex r1).
  if (document.documentElement.hasAttribute('data-ss-ab')) sections = sections.filter(function (el) { return getComputedStyle(el).display !== 'none'; });
  if (sections.length && 'IntersectionObserver' in window) {
    var seen = {}, timers = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target, key = sectionKey(el);
        if (!key || seen[key]) return;
        var vh = window.innerHeight || 0;
        var enough = en.isIntersecting && (en.intersectionRatio >= 0.5 || en.intersectionRect.height >= Math.min(el.offsetHeight, vh) * 0.5);
        if (enough) {
          if (!timers[key]) timers[key] = setTimeout(function () {
            timers[key] = 0;
            if (seen[key]) return;
            seen[key] = 1;
            io.unobserve(el);
            track('ss_section_view', { section: key, position: sections.indexOf(el) + 1 });
          }, 1000);
        } else if (timers[key]) { clearTimeout(timers[key]); timers[key] = 0; }
      });
    }, { threshold: (function () {
      // Fine steps so a section much taller than the viewport (a 4000 px story on an 800 px phone) still
      // crosses a threshold at the point where half the viewport is filled: 400 px = 0.1 of that section.
      var t = []; for (var s = 0; s <= 40; s++) t.push(s / 40); return t;
    })() });
    sections.forEach(function (el) { io.observe(el); });
  }

  // ─── ss_cta_click: links and the theme's own action buttons, outside the welcome popup (it reports itself).
  function destinationOf(el) {
    if (el.hasAttribute('data-ss-popup-opener')) return 'popup';
    if (el.hasAttribute('data-ss-open')) return '#' + String(el.getAttribute('data-ss-open') || '').slice(0, MAX - 1);
    if (el.hasAttribute('data-ss-buy')) return '#ss-buy';
    if (el.hasAttribute('data-ss-filter-submit')) return 'filter-submit';
    var href = el.getAttribute('href');
    if (!href) return '';
    if (href.indexOf('mailto:') === 0) return 'mailto';
    if (href.indexOf('tel:') === 0) return 'tel';
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return /(^|\.)amazon\.com$/.test(u.hostname) ? 'amazon' : 'external';
      return (u.pathname + (u.hash || '')).slice(0, MAX);
    } catch (e) { return ''; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('a[href], button[data-ss-open], button[data-ss-popup-opener], button[data-ss-buy], button[data-ss-filter-submit]');
    if (!el || el.closest('[id^="ss-popup-welcome-"]')) return;
    var dest = destinationOf(el);
    if (!dest) return;
    var sec = el.closest('.shopify-section');
    var params = { section: sectionKey(sec), destination: dest };
    var ctaId = el.getAttribute('data-ss-cta');
    if (ctaId) params.cta_id = ctaId;
    // Same-site page loads in this tab are the clicks that lose their event; hand those off.
    var navigates = dest.charAt(0) === '/' && el.tagName === 'A' && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey
      && (el.getAttribute('target') || '_self') === '_self' && dest.split('#')[0] !== location.pathname;
    track('ss_cta_click', params, navigates ? { handoff: true } : null);
  }, true);
})();
